import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { 
  SharedDataService,
  PS_PAFX_DR_Result,
  PS_PAFX_Fournisseur_Result,
  PafxFinancesFilters,
  PS_PAFX_Finances_Result,
  PafxFinancesNbCmdsFilters,
  PS_PAFX_Indicateur_Nb_Cdes_XRP_Result
 } from 'ngx-paf-common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinancesService {

  baseUrl!: string
  constructor(private http: HttpClient, private sharedDataSvc: SharedDataService) { 
    this.baseUrl = this.sharedDataSvc.apiBaseUrl + 'Finances/';
  }
  
  public Drs(topJoker:boolean=false):Observable<PS_PAFX_DR_Result[]>{
    return this.http.get<PS_PAFX_DR_Result[]>(`${this.baseUrl}drs/${topJoker?1:0}`);
  }
  public AllDrs(topJoker:boolean=false):Observable<PS_PAFX_DR_Result[]>{
    return this.http.get<PS_PAFX_DR_Result[]>(`${this.baseUrl}alldrs/${topJoker?1:0}`);
  }
  
  public Fournisseurs(searchParam:string):Observable<PS_PAFX_Fournisseur_Result[]>{
    return this.http.get<PS_PAFX_Fournisseur_Result[]>(`${this.baseUrl}fournisseurs/${searchParam}`);
  }
  
  public Groupes(searchParam:string):Observable<string[]>{
    return this.http.get<string[]>(`${this.baseUrl}groupes/${searchParam}`);
  }

  public Search(filters: PafxFinancesFilters):Observable<PS_PAFX_Finances_Result[]>{
    return this.http.post<PS_PAFX_Finances_Result[]>(`${this.baseUrl}search`, filters);
  }

  public SearchNbCommandes(filters: PafxFinancesNbCmdsFilters):Observable<PS_PAFX_Indicateur_Nb_Cdes_XRP_Result[]>{
    return this.http.post<PS_PAFX_Indicateur_Nb_Cdes_XRP_Result[]>(`${this.baseUrl}searchNbCommandes`, filters);
  }

}

